import AppTitle from '@theme/components/atom/AppTitle'
import Breadcrumbs from '@theme/components/molecule/Breadcrumbs'
import Divider from '@theme/components/molecule/Divider'
import FrequentQuestionBox from '@theme/components/content/FrequentQuestionBox'
import FrequentQuestionsCategoryBox from '@theme/components/content/FrequentQuestionsCategoryBox'
import ImageUrlMixin from '~/mixins/ImageUrlMixin'
import LayoutBase from '@theme/components/shop/LayoutBase'
import ProductsVisited from '@theme/components/product/ProductsVisited/ProductsVisitedLazy'
import SeoMixin from '~/mixins/SeoMixin'
import UniqueSellingPoints from '@theme/components/shop/UniqueSellingPoints'
import _ from 'lodash'

export default {
  components: {
    AppTitle,
    Breadcrumbs,
    Divider,
    FrequentQuestionBox,
    FrequentQuestionsCategoryBox,
    LayoutBase,
    ProductsVisited,
    UniqueSellingPoints,
  },
  props: {
    faqCategories: {
      type: Array,
    },
    faqQuestions: {
      type: Array,
    },
  },
  data() {
    return {
      breadcrumbs: [
        {
          title: this.$t('PageFaq.breadcrumbs.faq'),
          path: this.$route.path,
        },
      ],
      faqCategoryIcons: {}, //  'categoryId': require('@icon/icon_name.svg?raw'),
    }
  },
  head() {
    return this.getSeoHead({ yamlKey: 'PageFaq' })
  },
  methods: {
    faqCategoryIcon(faqCategoryId) {
      return _.get(this.faqCategoryIcons, faqCategoryId, require('@icon/information.svg?raw'))
    },
    scrollTo(e, id) {
      if (!e.metaKey) {
        e.stopPropagation()
        e.preventDefault()
        this.$scrollTo(`#${id}`)
        this.$router.push({ path: this.$router.path, hash: id })
      }
    },
  },
  mixins: [ImageUrlMixin, SeoMixin],
}
